module.exports = __webpack_public_path__ + "static/media/mbta-logo.d376ca96.png";